import React from "react";
import { StackDivider, VStack } from "@reverb-ui/react";
import { CompanyCard } from "./company-card";
export var CompanyList = function (_a) {
    var _b;
    var client = _a.client;
    return (React.createElement(VStack, { divider: React.createElement(StackDivider, { borderColor: "gray.200" }), height: "100%" },
        React.createElement(CompanyCard, { key: client.document, name: client.tradeName || client.name, industry: ((_b = client === null || client === void 0 ? void 0 : client.industry) === null || _b === void 0 ? void 0 : _b.description) || "-" })));
};
